import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type {
  CmsDocument,
  JsonPatchOperation,
  ServiceResponse,
  DocumentVersion,
} from '@dopomogai/types';

// All endpoints will be hit under /admin/cms/...
const ADMIN_CMS_PREFIX = '/admin/cms';

export const adminCmsService = {
  /** Replaces an entire document, creating a new version. */
  replaceDocument: (namespace: string, payload: CmsDocument): ServiceResponse<CmsDocument> => {
    return getApiClient()
      .put(`${ADMIN_CMS_PREFIX}/${namespace}`, payload)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, `replacing document '${namespace}'`));
  },

  /** Applies a JSON patch to a document, creating a new version. */
  patchDocument: (namespace: string, patchOps: JsonPatchOperation[]): ServiceResponse<CmsDocument> => {
    return getApiClient()
      .patch(`${ADMIN_CMS_PREFIX}/${namespace}`, patchOps)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, `patching document '${namespace}'`));
  },

  /** Lists the full version history for a document. */
  listVersions: (namespace: string): ServiceResponse<DocumentVersion[]> => {
     return getApiClient()
      .get(`${ADMIN_CMS_PREFIX}/${namespace}/versions`)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, `listing versions for '${namespace}'`));
  },

  /** Reverts a document to a previous version's state, creating a new version for the revert action. */
  revertToVersion: (namespace: string, version: number, commit_message: string): ServiceResponse<CmsDocument> => {
    return getApiClient()
      .post(`${ADMIN_CMS_PREFIX}/${namespace}/revert`, { version, commit_message })
      .then((res) => res.data)
      .catch((err) => handleApiError(err, `reverting document '${namespace}'`));
  }
};